import React from 'react';
import { Modal, Button, Typography, Row, Col } from 'antd';
import { LogoutBigIcon } from '../../../common/icons';

const { Text, Title } = Typography;

interface LogoutModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal
      open={isOpen}
      onOk={onConfirm}
      onCancel={onCancel}
      closable={false}
      width={330}
      centered
      footer={() => (
        <Row wrap={false} className="gap-8" style={{ marginTop: '24px' }}>
          <Button block size="large" onClick={onCancel}>
            Cancel
          </Button>
          <Button block size="large" type="primary" onClick={onConfirm}>
            Log Out
          </Button>
        </Row>
      )}
    >
      <Row gutter={[0, 12]} align="middle" justify="center" style={{ textAlign: 'center', padding: '20px 0' }}>
        <LogoutBigIcon />
        <Col span={24}>
          <Title level={3} style={{ margin: '16px 0 8px 0' }}>
            Log Out
          </Title>
        </Col>
        <Text style={{ color: '#525866' }}>Are you sure you want to log out?</Text>
      </Row>
    </Modal>
  );
};
